import React from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { Button } from "@mui/material";

export default function SchedulesPDF({ competencia, sessions }) {
  const {
    nombre = "Competencia",
    lugar = "",
    colorPrimario = "#0066CC",
    colorSecundario = "#FFFFFF",
  } = competencia || {};

  // Alturas y márgenes
  const headerHeight = 50;
  const footerHeight = 40;
  const sponsorSpace = 50;
  const bottomMargin = footerHeight + sponsorSpace;

  const formatDDMMYYYY = (isoDate) => {
    if (!isoDate) return "";
    const [yyyy, mm, dd] = isoDate.split("-");
    return `${dd}/${mm}/${yyyy}`;
  };

  // Encabezado general
  const drawGeneralHeader = (doc, pageWidth) => {
    doc.setFillColor(colorPrimario);
    doc.rect(0, 0, pageWidth, headerHeight, "F");
    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.setTextColor(colorSecundario);

    doc.text(nombre, pageWidth / 2, 25, { align: "center" });

    if (lugar) {
      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      doc.text(`Lugar: ${lugar}`, pageWidth / 2, 40, { align: "center" });
    }
  };

  // Pie de página
  const drawFooter = (doc, pageIndex, totalPages, pageWidth, pageHeight) => {
    doc.setFillColor(colorPrimario);
    doc.rect(0, pageHeight - 40, pageWidth, 40, "F");

    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.setTextColor(colorSecundario);

    doc.text(
      "Documento generado automáticamente - SportCompass",
      pageWidth / 2,
      pageHeight - 40 / 2 + 4,
      { align: "center" }
    );

    doc.text(
      `Página ${pageIndex} de ${totalPages}`,
      pageWidth - 70,
      pageHeight - 40 / 2 + 4
    );

    // Patrocinadores
    doc.setFillColor("#FFFFFF");
    doc.rect(0, pageHeight - bottomMargin, pageWidth, sponsorSpace, "F");
    doc.setFontSize(8);
    doc.setTextColor("#000000");
    doc.text(
      "Espacio para patrocinadores",
      pageWidth / 2,
      pageHeight - bottomMargin + 15,
      { align: "center" }
    );
  };

  const generatePDF = () => {
    const doc = new jsPDF("p", "pt", "letter");
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    // Columnas de la tabla
    const tableColumns = [
      { header: "Hora", dataKey: "hora" },
      { header: "#Evento", dataKey: "evento" },
      { header: "Prueba", dataKey: "prueba" },
      { header: "Categoría", dataKey: "categoria" },
      { header: "Rama", dataKey: "rama" },
      { header: "Esp", dataKey: "especificaciones" },
      { header: "Fase", dataKey: "fase" },
      { header: "Heats", dataKey: "heats" },
      { header: "Inscritos", dataKey: "inscritos" },
    ];

    sessions.forEach((session, idx) => {
      if (idx > 0) doc.addPage();

      // Prepara las filas
      const tableRows = session.schedules.map((sched) => ({
        hora: sched.hora || "",
        evento: String(sched.evento || ""),
        prueba: sched.prueba || "",
        categoria: sched.categoria || "",
        rama: sched.rama || "",
        especificaciones: sched.especificaciones || "",
        fase: sched.fase || "",
        heats: String(sched.heats || ""),
        inscritos: String(sched.inscritos || ""),
      }));

      // Dibuja info de la sesión en cada página
      const didDrawPageForSession = () => {
        drawGeneralHeader(doc, pageWidth);

        doc.setFont("helvetica", "bold");
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);

        const ySessionTitle = headerHeight + 20;
        doc.text(
          `Sesión #${session.number}: ${session.name}`,
          pageWidth / 2,
          ySessionTitle,
          { align: "center" }
        );

        const ySessionDate = ySessionTitle + 14;
        const fechaFormateada = formatDDMMYYYY(session.date);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(11);
        doc.text(`Fecha: ${fechaFormateada}`, pageWidth / 2, ySessionDate, {
          align: "center",
        });

        const ySessionTime = ySessionDate + 14;
        doc.text(
          `Hora de inicio: ${session.startTime || "N/D"}`,
          pageWidth / 2,
          ySessionTime,
          { align: "center" }
        );
      };

      doc.autoTable({
        margin: {
          top: headerHeight + 55, // <-- se incrementa a 100
          bottom: bottomMargin + 10,
          left: 40,
          right: 40,
        },
        head: [tableColumns.map((c) => c.header)],
        body: tableRows.map((row) => tableColumns.map((c) => row[c.dataKey])),
        styles: {
          fontSize: 10,
          cellPadding: 4,
        },
        headStyles: {
          fillColor: colorPrimario,
          textColor: "#FFFFFF",
        },
        tableWidth: "auto",
        repeatHead: true,
        didDrawPage: () => {
          // Se dibuja el encabezado (barra + nombre comp + lugar) y la info de la sesión
          didDrawPageForSession();
        },
      });
    });

    // Re-dibujamos footers con el número de página correcto
    const totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      drawFooter(doc, i, totalPages, pageWidth, pageHeight);
    }

    doc.save("horarios_competencia.pdf");
  };

  return (
    <Button variant="contained" color="primary" onClick={generatePDF}>
      Descargar Horarios
    </Button>
  );
}
